import { useState, useCallback, Fragment } from "react";
import { Button, Modal, message } from "antd";
import { useRequest } from "ahooks";
import { useNavigate } from "react-router-dom";
import {
  message as messageService,
  department as departmentService,
} from "@/services";
import { useAuthContext } from "@/components/auth/AuthProvider";

function PublishButton({ messageId, form }) {
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const auth = useAuthContext();
  const clickHandler = useCallback(() => {
    setVisible(true);
  }, [setVisible]);
  const okHandler = useCallback(async () => {
    const results = await form.validate();
    if (results) {
      setVisible(false);
      return;
    }
    const values = form.values;
    const { attachments = [], subjects = [] } = values;
    if (messageId) {
      setLoading(true);
      messageService
        .updateMessage(
          messageId,
          {
            ...values,
            status: 1,
            attachments: attachments.map((a) => a.response.id),
            subjects: subjects.split("，").map((s) => ({ name: s })),
          },
          auth.token
        )
        .then((res) => {
          message.success("操作成功");
          navigate("/workshop/msubm/draft");
        })
        .finally(() => {
          setVisible(false);
          setLoading(false);
        });
    } else {
      setLoading(true);
      messageService
        .createMessage(
          {
            ...values,
            status: 1,
            attachments: attachments.map((a) => a.response.id),
            subjects: subjects.split("，").map((s) => ({ name: s })),
          },
          auth.token
        )
        .then((res) => {
          if (res.status_code === 400) {
            const { status_code, ...rest } = res;
            const messages = Object.values(rest).flat();
            message.error(messages.join(", "));
          } else {
            setVisible(false);
            message.success("操作成功");
            navigate("/workshop/msubm/draft");
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [messageId, auth, form, navigate]);
  const cancelHandler = useCallback(() => {
    setLoading(false);
    setVisible(false);
  }, [setVisible]);

  const { title, sendee } = form.values;
  const { data } = useRequest(
    () => departmentService.display(sendee, auth.token),
    {
      ready: !!sendee,
      refreshDeps: [sendee],
    }
  );
  return (
    <Fragment>
      <Button onClick={clickHandler}>上报</Button>

      <Modal
        title="确认上报"
        visible={visible}
        onOk={okHandler}
        okButtonProps={{ loading }}
        onCancel={cancelHandler}
        okText="确认"
        cancelText="取消"
      >
        <p>接收单位：{data?.name}</p>
        <p>信息标题：{title}</p>
      </Modal>
    </Fragment>
  );
}

export default PublishButton;
